import React, { useEffect } from "react";
import { useStore } from "../helpers";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { SideOverlay, UpdateProfile, UserAgreement } from "../components";
import { observer } from "mobx-react-lite";
import Shell from "../layouts/app-shell";

export const PrivateRoute = observer((props: any) => {
  const rootStore = useStore();
  const { userStore } = rootStore;
  const { isAuthorized, hasCheckedAuth } = userStore;
  const { projectid } = useParams();

  const location = useLocation();

  // Use already-checked auth state from userStore instead of calling checkLogin() again
  // checkLogin() is already called in RootStore constructor
  const isCheckedIn = hasCheckedAuth ? isAuthorized : userStore.checkLogin();

  useEffect(() => {
    // Only logout if auth check is complete AND user is not authorized
    // This prevents premature logout during initial auth check race condition
    if (hasCheckedAuth && !isAuthorized) {
      userStore.logout();
    }
  }, [hasCheckedAuth, isAuthorized]);

  return (
    <div>
      {isCheckedIn ? (
        <>
          <main className="modern-dashboard-bg min-h-[100vh]">
            <Shell>
              <Outlet />
              <UserAgreement key={projectid} />
            </Shell>

            <SideOverlay
              children={<UpdateProfile />}
              onClose={() => userStore.set_profile_update(false)}
              show={userStore.profile_update}
              title={"Update Profile"}
            />
          </main>
        </>
      ) : (
        <Navigate to="/login" state={{ path: location.pathname }} />
      )}
    </div>
  );
});

// @ts-ignore
export const PublicRoute = ({ component: Component, ...rest }) => {
  return <Component {...rest} />;
};
